const LimitType = Object.freeze({
  AI_RESPONSES: 'ai_responses',
  SEARCHES: 'searches',
} as const);

export type LimitType = (typeof LimitType)[keyof typeof LimitType];

export default LimitType;
